import React, { Component } from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import './MyBoard.scss';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import moment from "moment/moment";
import ModalLoading from "../../../components/common/ModalLoading";
import {
  Badge,
  Button,
  ButtonGroup,
  FormInput,
  FormSelect,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import { toast } from "react-toastify";
import { reactLocalStorage as Storage } from "reactjs-localstorage";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ board }) => ({getBoardList: board.getBoardList, updateBoard: board.updateBoard}))

@observer
class MyBoard extends Component {

  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {};
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  @observable storageCfg = {
    is: true,
    etcType: "fn"
  };

  @observable listParams = {
    page: 1,
    limit: 100,
    displayStatus: 100,
    searchParams: {
      status: 'all'
    }
  };
  @observable list = {};
  @observable searchFormValue = {
    status: 'all',
    keyword: ''
  };

  @observable modals = {
    isDetail: false,
    detailData: {},
  };

  constructor(props) {
    super(props);
    this.init();
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
  }

  @action
  init = async (key) => {
    if (this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store;
      this.listParams.store_id = this.store._id;

      let storageCfg = await Storage.getObject('storageCfg');
      if (storageCfg.is) {
        this.storageCfg = storageCfg;
      }

      this.permissions = this.props.me.permissions;
      this.urlParamsToListParams();
    }
    else {
      if (Storage.get('token')) {
      }
    }
  };

  @action
  getList = async () => {
    Storage.set('limitMyBoardList', this.listParams.limit);
    if (this.listParams.store_id) {
      // 내 문의(설치요청/문의하기)만 노출 — qna(FAQ) 등 다른 게시판이 섞이지 않도록 boardName 제한
      // boardNameIn: 백엔드가 $in 으로 처리(구버전은 무시 → 빈 목록 깨짐 방지)
      this.listParams.searchParams.store_id = this.listParams.store_id;
      this.listParams.searchParams.boardNameIn = ['installationRequest', 'inquiry'];
      this.list = await this.props.getBoardList(this.listParams);
      this.isLoading = false;
    }
    else {
      this.isLoading = false;
    }
  };

  urlParamsToListParams = function () {
    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {
      if (['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if (key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if (!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {}; }
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          if (this.urlParams.get(key) === "true") {
            this.searchFormValue[key] = true;
            this.listParams.searchParams[key] = true;
          }
          else if (this.urlParams.get(key) === "false") {
            this.searchFormValue[key] = false;
            this.listParams.searchParams[key] = false;
          }
          else {
            this.searchFormValue[key] = this.urlParams.get(key);
            this.listParams.searchParams[key] = this.urlParams.get(key);
          }
        }
      }
    }

    for (let key in searchFormValueArr) {
      if (searchFormValueArr[key].all) {
        for (let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for (let deKey in this.searchFormValue[key]) {
          if (searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }

    this.getList();
  };

  onChangeValue = async (event) => {
    const { name, value } = event.target;
    this.teamUser[name] = value;
  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if (type === 'checkbox') {
      if (value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if (obj) {
      obj[name] = newValue;
    }
    else {
      this.searchFormValue[name] = newValue;
    }

    if (name === "sort") {
      this.listParams.sort = newValue;
      this.getList();
    }
  };

  onChangeStorageCfg = async (targetObj, val, key) => {
    if (key) {
      targetObj[key] = val;
    }
    else {
      targetObj = val;
    }
    Storage.setObject('storageCfg', this.storageCfg);
  };

  modalToggle = function (target, data) {
    let _this = this;
    if (!target) {
      for (var i in _this.modals) {
        if (i.indexOf('is') === 0) {
          _this.modals[i] = false;
        }
      }
    }
    else {
      _this.modals[target] = !this.modals[target];
    }

    if (data) {
      if (target === 'isDetail' && data) {
        _this.modals.detailData = data;
      }
      else {
        _this.modals.data = data;
      }
    }
  };

  onChangeModalInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    targetObj[name] = value;
  };

  updateMyBoard = async () => {
    let params = {
      id: this.modals.detailData._id,
      store_id: this.modals.detailData.store_id._id,
      shopNo: this.modals.detailData.shopNo,
      boardName: this.modals.detailData.boardName,
      info_1: this.modals.detailData.info_1,
      info_2: this.modals.detailData.info_2,
      info_3: this.modals.detailData.info_3,
      status: 'published' // 수정 시 대기중 상태로 변경
    };
    console.log(params);
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
    } else {
      toast('정보가 수정되었습니다. 상태가 대기중으로 변경되었습니다.');
      this.modals.isDetail = false; // 모달 닫기
      this.getList();
    }
  };

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum - 1) / 10) * 10) + 1;
      let endNum = startNum + 9 < totalPages ? startNum + 9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for (let i = startNum; i <= endNum; i++) {
          if (i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page=" + i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page=" + i}>{i}</a></li>);
          }
        }
        return result;
      };

      if (_this.list && _this.list.totalPages) {
        return (
          <div className="pagination">
            <ul>
              {curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
              {startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page=" + (startNum - 1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
              {rendering()}
              {endNum !== totalPages ? <li className="btn-page-next"><a href={urlParams + "&page=" + (startNum + 10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
              {curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page=" + totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
            </ul>
          </div>);
      }
      else {
        return (<></>);
      }
    }

    function BoardName(props) {
      let statusDom = '';
      switch (props.boardName) {
        case "installationRequest":
          statusDom = <><strong>설치 요청</strong> <Badge theme="success">요청</Badge></>;
          break;
        case "inquiry":
          statusDom = <><strong>문의하기</strong> <Badge theme="info">문의</Badge></>;
          break;
        case "approved":
          statusDom = <Badge theme="success">승인</Badge>;
          break;
        case "rejected":
          statusDom = <Badge theme="success">반려</Badge>;
          break;
        case "in_progress":
          statusDom = <Badge theme="success">진행중</Badge>;
          break;
        case "completed":
          statusDom = <Badge theme="success">완료</Badge>;
          break;
        default:
          statusDom = <Badge outline theme="success">{props.boardName}</Badge>;
          break;
      }
      return statusDom;
    }
    function GetStatusBadge(props) {
      let statusDom = '';
      switch (props.status) {
        case "published":
          statusDom = <Badge theme="secondary">대기중</Badge>;
          break;
        case "in_progress":
          statusDom = <Badge theme="info">설치중</Badge>;
          break;
        case "install_end":
          statusDom = <Badge theme="success">설치완료</Badge>;
          break;
        case "rejected":
          statusDom = <Badge theme="warning">진행 보류</Badge>;
          break;
        case "completed":
          statusDom = <Badge theme="success">완료</Badge>;
          break;
        default:
          statusDom = <Badge outline theme="info">{props.status}</Badge>;
          break;
      }
      return statusDom;
    }

    function formatFileSize(size) {
      if (!size && size !== 0) return '';
      if (size < 1024) return size + ' B';
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
      return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function AttachmentList(props) {
      const items = props.items || [];
      if (!items.length) return null;
      return (
        <ul className="myboard-attachments">
          {items.map((file, idx) => {
            const filename = (file && file.meta && file.meta.filename) || (file && file.name) || (file && file.url ? file.url.split('/').pop() : ('첨부 ' + (idx + 1)));
            const isImage = file && (file.type === 'image' || (typeof file.type === 'string' && file.type.startsWith('image/'))) && file.url;
            return (
              <li key={idx} className="myboard-attachments__item">
                {isImage ? (
                  <a href={file.url} target="_blank" rel="noopener noreferrer">
                    <img src={file.url} alt={filename} className="myboard-attachments__thumb" />
                  </a>
                ) : (
                  <FeatherIcon icon={file && file.type === 'video' ? 'film' : file && file.type === 'link' ? 'link' : 'paperclip'} size="14" />
                )}
                <a
                  href={file && file.url ? file.url : '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="myboard-attachments__name"
                  onClick={e => { if (!file || !file.url) e.preventDefault(); }}
                >
                  {filename}
                </a>
                {file && file.size ? (
                  <span className="myboard-attachments__size">({formatFileSize(file.size)})</span>
                ) : null}
              </li>
            );
          })}
        </ul>
      );
    }

    return (
      <div className="main-content">
        <PageTitle />
        <div className="user-list-box">
          {/*<div className="section-box">*/}
          {/*  <form id="" target="" className="">*/}
          {/*    <div className="user-search-box">*/}
          {/*      <table>*/}
          {/*        <tbody>*/}
          {/*          <tr>*/}
          {/*            <th>검색어</th>*/}
          {/*            <td>*/}
          {/*              <div className="search-input-box">*/}
          {/*                <input type="text" name="keyword" className="table-input-text search-input"*/}
          {/*                       value={this.searchFormValue.keyword}*/}
          {/*                       onChange={event => this.onChangeSearchValue(event)} />*/}
          {/*              </div>*/}
          {/*            </td>*/}
          {/*          </tr>*/}
          {/*          <tr>*/}
          {/*            <th>상태</th>*/}
          {/*            <td>*/}
          {/*              <label className="">*/}
          {/*                <input type="checkbox" name="pending" onChange={event => {*/}
          {/*                  this.onChangeSearchValue(event)*/}
          {/*                }} value={this.searchFormValue.pending}*/}
          {/*                       checked={Boolean(this.searchFormValue.pending)} />*/}
          {/*                <span>대기중</span>*/}
          {/*              </label>*/}

          {/*              <label className="ml-5">*/}
          {/*                <input type="checkbox" name="approved" onChange={event => {*/}
          {/*                  this.onChangeSearchValue(event)*/}
          {/*                }} value={this.searchFormValue.approved}*/}
          {/*                       checked={Boolean(this.searchFormValue.approved)} />*/}
          {/*                <span>승인</span>*/}
          {/*              </label>*/}

          {/*              <label className="ml-5">*/}
          {/*                <input type="checkbox" name="rejected" onChange={event => {*/}
          {/*                  this.onChangeSearchValue(event)*/}
          {/*                }} value={this.searchFormValue.rejected}*/}
          {/*                       checked={Boolean(this.searchFormValue.rejected)} />*/}
          {/*                <span>반려</span>*/}
          {/*              </label>*/}

          {/*              <label className="ml-5">*/}
          {/*                <input type="checkbox" name="completed" onChange={event => {*/}
          {/*                  this.onChangeSearchValue(event)*/}
          {/*                }} value={this.searchFormValue.completed}*/}
          {/*                       checked={Boolean(this.searchFormValue.completed)} />*/}
          {/*                <span>완료</span>*/}
          {/*              </label>*/}
          {/*            </td>*/}
          {/*          </tr>*/}
          {/*        </tbody>*/}
          {/*      </table>*/}
          {/*      <div className="btn-search">*/}
          {/*        <input type="submit" value="검색" className="search-button" />*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  </form>*/}
          {/*</div>*/}

          <div className="section-box">
            <form id="" target="" className="">
              <div className="user-list-table">
                <div className="user-pick-list">
                  <div className="pick-list-count">
                    내 문의 내역 <span>{this.list.totalDocs || 0}</span>개
                  </div>
                  <div className="choice-num-view">
                    {/*<select name="limit"*/}
                    {/*        value={this.listParams.limit}*/}
                    {/*        onChange={event => {*/}
                    {/*          this.listParams.limit = parseInt(event.target.value);*/}
                    {/*          this.onChangeSearchValue(event, this.listParams);*/}
                    {/*        }}*/}
                    {/*        className="">*/}
                    {/*  <option value="50">50개씩 보기</option>*/}
                    {/*  <option value="100">100개씩 보기</option>*/}
                    {/*  <option value="200">200개씩 보기</option>*/}
                    {/*  <option value="20">20개씩 보기</option>*/}
                    {/*</select>*/}
                    {/*<select name="sort"*/}
                    {/*        value={this.listParams.sort}*/}
                    {/*        onChange={event => {*/}
                    {/*          this.listParams.sort = event.target.value;*/}
                    {/*          this.onChangeSearchValue(event, this.listParams);*/}
                    {/*        }}*/}
                    {/*        className="">*/}
                    {/*  <option value="createdAt">신청일순</option>*/}
                    {/*  <option value="updatedAt">수정일순</option>*/}
                    {/*</select>*/}
                  </div>
                </div>
                <table className="store-list">
                  <colgroup>
                    <col width="" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>문의내용</th>
                      <th>상태</th>
                      <th>신청일</th>
                      <th>상세</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.list && this.list.docs && this.list.docs.length > 0 ?
                      this.list.docs.map((item, i) => (
                        <tr key={i}>
                          <td className={"text-left"}>
                            <BoardName boardName={item.boardName} />
                            {item.boardName === 'inquiry' && (
                              <div style={{marginTop: '8px'}}>
                                <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                                  {item.title || '-'}
                                </div>
                                <div style={{fontSize: '0.9em', color: '#666', maxWidth: '400px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                  {item.content || '-'}
                                </div>
                              </div>
                            )}
                          </td>
                          <td className="text-center">
                            <GetStatusBadge status={item.status} />
                          </td>
                          <td>{moment(item.createdAt).format('YYYY.MM.DD HH:mm')}</td>
                          <td className="text-center">
                            <Button size="sm" onClick={() => this.modalToggle('isDetail', item)}>상세보기</Button>
                          </td>
                        </tr>))
                      :
                      <tr>
                        <td colSpan={6} className="text-center">내 문의 내역이 없습니다</td>
                      </tr>
                    }
                  </tbody>
                </table>
                <Pagination />
              </div>
            </form>
          </div>
        </div>

        <Modal size="lg" className='modal-my-board-detail' open={this.modals.isDetail} toggle={() => this.modals.isDetail = false} centered={true}>
          <ModalHeader toggle={() => this.modals.isDetail = false}>내 문의 상세</ModalHeader>
          <ModalBody className="history-window-popup">
            <div className="history-popup-contents">
              {this.modals.detailData && this.modals.detailData.store_id ? (
                <table>
                  <colgroup>
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '35%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '35%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>게시판</th>
                      <td><BoardName boardName={this.modals.detailData.boardName} /></td>
                      <th>상태</th>
                      <td><GetStatusBadge status={this.modals.detailData.status} /></td>
                    </tr>
                    <tr>
                      <th>연락처</th>
                      <td>{this.modals.detailData.contact}</td>
                      <th>이메일</th>
                      <td>{this.modals.detailData.email}</td>
                    </tr>
                    <tr>
                      <th>신청일</th>
                      <td>{moment(this.modals.detailData.createdAt).format('YYYY.MM.DD HH:mm')}</td>
                      <th>처리일</th>
                      <td>{this.modals.detailData.processedAt ? moment(this.modals.detailData.processedAt).format('YYYY.MM.DD HH:mm') : '-'}</td>
                    </tr>
                    <tr>
                      <th>문의 / 요청사항</th>
                      <td colSpan="3"><pre>{this.modals.detailData.content || '-'}</pre></td>
                    </tr>
                    {Array.isArray(this.modals.detailData.attachments) && this.modals.detailData.attachments.length > 0 && (
                      <tr>
                        <th>첨부 파일</th>
                        <td colSpan="3">
                          <AttachmentList items={this.modals.detailData.attachments} />
                        </td>
                      </tr>
                    )}
                    {this.modals.detailData.boardName === 'installationRequest' && (
                      <>
                        <tr>
                          <th>카페24 계정</th>
                          <td>
                            {this.modals.detailData.status === 'rejected' ? (
                              <FormInput
                                  name="info_1"
                                  value={this.modals.detailData.info_1 || ''}
                                  onChange={event => this.onChangeModalInputs(event, this.modals.detailData)}
                                  style={{width: '100%'}}
                              />
                            ) : (
                              this.modals.detailData.info_1 || '-'
                            )}
                          </td>
                          <th>카페24 비밀번호</th>
                          <td>
                            {this.modals.detailData.status === 'rejected' ? (
                              <FormInput
                                  name="info_2"
                                  type="password"
                                  value={this.modals.detailData.info_2 || ''}
                                  onChange={event => this.onChangeModalInputs(event, this.modals.detailData)}
                                  style={{width: '100%'}}
                              />
                            ) : (
                              this.modals.detailData.info_2 || '-'
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>계정유형</th>
                          <td colSpan="3">
                            {this.modals.detailData.status === 'rejected' ? (
                              <FormSelect
                                  name="info_3"
                                  value={this.modals.detailData.info_3 || ''}
                                  onChange={event => this.onChangeModalInputs(event, this.modals.detailData)}
                                  style={{width: '100%'}}
                              >
                                <option value="">계정유형을 선택하세요</option>
                                <option value="main">주계정</option>
                                <option value="sub">부계정</option>
                              </FormSelect>
                            ) : (
                              this.modals.detailData.info_3 === 'primary' ? '주계정' :
                              this.modals.detailData.info_3 === 'secondary' ? '부계정' :
                              (this.modals.detailData.info_3 || '-')
                            )}
                          </td>
                        </tr>
                      </>
                    )}
                    {this.modals.detailData.boardName === 'inquiry' && (
                      <>
                        <tr>
                          <th>문의 제목</th>
                          <td colSpan="3">{this.modals.detailData.title || '-'}</td>
                        </tr>
                        <tr>
                          <th>문의 유형</th>
                          <td colSpan="3">
                            {this.modals.detailData.inquiryType === 'general' ? '일반 문의' :
                             this.modals.detailData.inquiryType === 'technical' ? '기술 문의' :
                             this.modals.detailData.inquiryType === 'billing' ? '결제 문의' :
                             this.modals.detailData.inquiryType === 'feature' ? '기능 개선 제안' :
                             this.modals.detailData.inquiryType === 'bug' ? '버그 신고' :
                             this.modals.detailData.inquiryType === 'other' ? '기타' :
                             (this.modals.detailData.inquiryType || '-')}
                          </td>
                        </tr>
                      </>
                    )}
                    <tr>
                      <th>답변</th>
                      <td colSpan="3"><pre>{this.modals.detailData.comment || '답변 대기 중입니다.'}</pre></td>
                    </tr>
                    {Array.isArray(this.modals.detailData.commentAttachments) && this.modals.detailData.commentAttachments.length > 0 && (
                      <tr>
                        <th>답변 첨부</th>
                        <td colSpan="3">
                          <AttachmentList items={this.modals.detailData.commentAttachments} />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>) : null}

              <div className="text-center mt-2">
                {this.modals.detailData && this.modals.detailData.status === 'rejected' && this.modals.detailData.boardName === 'installationRequest' ? (
                  <ButtonGroup>
                    <Button theme="primary" onClick={e => this.updateMyBoard()}>저장</Button>
                    <Button theme="light" onClick={() => this.modals.isDetail = false}>닫기</Button>
                  </ButtonGroup>
                ) : (
                  <Button theme="light" onClick={() => this.modals.isDetail = false}>닫기</Button>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ModalLoading isLoading={this.isLoading} />
      </div>
    )
  }
}

export default MyBoard;